import React, {FunctionComponent} from 'react';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import './Modal.css';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        modal: {
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'flex-start',
            justifyContent: 'center',
        }
    }),
);

interface IModalWrapper {
    header: string;
    onClose: () => void;
    buttons: JSX.Element;
}

const ModalWrapper: FunctionComponent<IModalWrapper> = (props) => {
  const {header, onClose, buttons} = props;
  const classes = useStyles();
  return (
      <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          className={classes.modal}
          open={true}
          onClose={onClose}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
              timeout: 500,
          }}
      >
          <Fade in={true}>
              <div className={`modal-dialog`} style={{minWidth: '320px'}}>
                  <div className="modal-content">
                      <div className="modal-header">
                          <button type="button" className="close" onClick={onClose}>&times;</button>
                          <h5 className="modal-title">{header}</h5>
                      </div>
                      <div className="modal-body">
                          {props.children}
                      </div>
                      <div className="modal-footer">
                          <button type="button" className="btn btn-link" onClick={onClose}>Close</button>
                          {buttons}
                      </div>
                  </div>
              </div>
          </Fade>
      </Modal>
  )
};

export default ModalWrapper;
